import React from 'react'
import { Card } from 'react-bootstrap'
import moment from 'moment'
import { Chat } from './types'
import ChatAvatars from './chat-avatars'
import { truncateString } from 'utils/string'

interface ChatCardProps {
  chat: Chat
  onSelect: () => void
  isSelected?: boolean
}

const ChatCard: React.FC<ChatCardProps> = ({
  chat,
  onSelect,
  isSelected = false,
}) => {
  const formatMessageTime = (timestamp: string) => {
    const messageDate = moment(timestamp)
    const now = moment()

    // If today, show time
    if (messageDate.isSame(now, 'day')) {
      return messageDate.format('h:mmA')
    }

    // If this week, show day of week
    if (messageDate.isSame(now, 'week')) {
      return messageDate.format('ddd')
    }

    // Otherwise show date in MM/DD/YY format
    return messageDate.format('MM/DD/YY')
  }
  return (
    <Card
      style={{
        cursor: 'pointer',
        border: 'none',
        background: isSelected ? '#454545' : 'transparent',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '0',
      }}
      onClick={onSelect}
    >
      <Card.Body style={{ padding: 'clamp(8px, 2vw, 16px)' }}>
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="d-flex align-items-center"
            style={{ flex: 1, minWidth: 0 }}
          >
            <div
              className="me-3"
              style={{
                flexShrink: 0,
                width: 'clamp(40px, 12vw, 48px)',
                height: 'clamp(40px, 12vw, 48px)',
              }}
            >
              <ChatAvatars chat={chat} size={48} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                className="fw-bold"
                style={{ fontSize: 'clamp(14px, 4vw, 16px)' }}
              >
                {truncateString(chat.display_name, 40)}
                {chat.group && (
                  <span
                    className="badge bg-secondary ms-2"
                    style={{
                      fontSize: 'clamp(10px, 2.5vw, 12px)',
                      fontWeight: '500',
                    }}
                  >
                    Group
                  </span>
                )}
              </div>
              <div
                style={{
                  fontSize: 'clamp(13px, 3.5vw, 15px)',
                  color: 'white',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '100%',
                }}
              >
                {chat.last_message.is_from_me ? 'You: ' : ''}
                {chat.last_message.text}
              </div>
            </div>
          </div>
          <div
            className="d-flex flex-column align-items-end ms-3"
            style={{ minWidth: 'clamp(60px, 15vw, 80px)' }}
          >
            <span
              style={{
                fontSize: 'clamp(12px, 3vw, 15px)',
                color: 'white',
                fontWeight: 500,
              }}
            >
              {formatMessageTime(chat.last_message.sent_at)}
            </span>
            <ion-icon
              name="chevron-forward"
              style={{ color: '#1DA1F2', fontSize: 'clamp(16px, 4vw, 18px)' }}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default ChatCard
